import { render, staticRenderFns } from "./ClientNumDlg.vue?vue&type=template&id=126eb2c5&scoped=true"
import script from "./ClientNumDlg.vue?vue&type=script&lang=js"
export * from "./ClientNumDlg.vue?vue&type=script&lang=js"
import style0 from "./ClientNumDlg.vue?vue&type=style&index=0&id=126eb2c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126eb2c5",
  null
  
)

export default component.exports